import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

// ============ Types ============

export type CreateResendFeedbackRequestInput = {
  eventId: number;
  type: 'IMMEDIATE' | 'SCHEDULED';
  sendAt: string;
  notificationChannel: {
    email: boolean;
    slack: boolean;
  };
};

type CreateResendFeedbackRequestResponse = {
  createResendFeedbackRequest: {
    feedbackRequest: {
      id: number;
    };
  };
};

export type UpdateResendFeedbackRequestInput = {
  requestId: number;
  type: 'IMMEDIATE' | 'SCHEDULED';
  sendAt: string;
  notificationChannel: {
    email: boolean;
    slack: boolean;
  };
};

type UpdateResendFeedbackRequestResponse = {
  updateResendFeedbackRequest: {
    feedbackRequest: {
      id: number;
    };
  };
};

type DeleteResendFeedbackRequestResponse = {
  deleteResendFeedbackRequest: {
    ok: boolean;
  };
};

// ============ Mutations ============

const CREATE_RESEND_FEEDBACK_REQUEST_MUTATION = gql`
  mutation createResendFeedbackRequest($input: CreateResendFeedbackRequestInput!) {
    createResendFeedbackRequest(input: $input) {
      feedbackRequest {
        id
      }
    }
  }
`;

const UPDATE_RESEND_FEEDBACK_REQUEST_MUTATION = gql`
  mutation updateResendFeedbackRequest($input: UpdateResendFeedbackRequestInput!) {
    updateResendFeedbackRequest(input: $input) {
      feedbackRequest {
        id
      }
    }
  }
`;

const DELETE_RESEND_FEEDBACK_REQUEST_MUTATION = gql`
  mutation deleteResendFeedbackRequest($input: DeleteResendFeedbackRequestInput!) {
    deleteResendFeedbackRequest(input: $input) {
      ok
    }
  }
`;

// ============ API ============

export const resendFeedbackRequestApi = {
  create: async (
    input: CreateResendFeedbackRequestInput
  ): Promise<CreateResendFeedbackRequestResponse['createResendFeedbackRequest']> => {
    return gqlClient
      .request<CreateResendFeedbackRequestResponse>(CREATE_RESEND_FEEDBACK_REQUEST_MUTATION, {
        input
      })
      .then((res) => res.createResendFeedbackRequest);
  },
  update: async (
    input: UpdateResendFeedbackRequestInput
  ): Promise<UpdateResendFeedbackRequestResponse['updateResendFeedbackRequest']> => {
    return gqlClient
      .request<UpdateResendFeedbackRequestResponse>(UPDATE_RESEND_FEEDBACK_REQUEST_MUTATION, {
        input
      })
      .then((res) => res.updateResendFeedbackRequest);
  },
  delete: async (
    requestId: number
  ): Promise<DeleteResendFeedbackRequestResponse['deleteResendFeedbackRequest']> => {
    return gqlClient
      .request<DeleteResendFeedbackRequestResponse>(DELETE_RESEND_FEEDBACK_REQUEST_MUTATION, {
        input: { requestId }
      })
      .then((res) => res.deleteResendFeedbackRequest);
  }
};
